import { createSlice } from '@reduxjs/toolkit';

export interface redeemRewardsState {
  redeemRewardsData: any | null;
  redeemRewardsPreferenceData: any | null;
  redeemRewardSearchData: any | null;
  redeemRewardsLoding: boolean;
  redeemRewardsError: any | null;
  redeemRewardsPreferenceLoding: boolean;
  redeemRewardsPreferenceError: any | null;
  updateRedeemRewardsPreferenceData: any | null;
  updateredeemRewardsPreferenceLoding: boolean;
  updateredeemRewardsPreferenceError: any | null;
  redeemRewardSearchLoading: boolean;
  redeemRewardSearchError: any | null;
  rewardsTransactionLoding: boolean;
  rewardsTransactionList: any | null;
  error: string | null;
  rewardsPointsloading: boolean;
  rewardsPoints: any | null;
  rewardsPointsError: any | null;
  rewardsPointsAdjustmentsDetailsloading: boolean;
  rewardsPointsAdjustmentsDetails: any | null;
  rewardsPointsAdjustmentsDetailsError: any | null;
  rewardsUserPreferenceloading: boolean;
  rewardsUserPreference: any | null;
  rewardsUserPreferenceError: any | null;
  redeemRewardsAuthorizationLoding: boolean;
  redeemRewardsAuthorizationList: any | null;
  authorizationerror: any | null;
  updateRedeemRewardsAuthorization: any | null;
  updateredeemRewardsAuthorizationLoding: any | null;
  updateauthorizationerror: any | null;
  authorizationReprocess: any | null;
  authorizationReprocessLoding: any | null;
  authorizationReprocessError: any | null;
  rewardsPercentageDate: any | null;
  rewardsPercentageDateLoading: any | null;
  rewardsPercentageDateError: any | null;
  noEligibleTransaction: any | null;
}

const initialState: redeemRewardsState = {
  redeemRewardsData: null,
  redeemRewardsPreferenceData: null,
  redeemRewardSearchData: null,
  redeemRewardsLoding: false,
  redeemRewardsError: null,
  redeemRewardsPreferenceLoding: false,
  redeemRewardsPreferenceError: null,
  updateRedeemRewardsPreferenceData: null,
  updateredeemRewardsPreferenceLoding: false,
  updateredeemRewardsPreferenceError: null,
  redeemRewardSearchLoading: false,
  redeemRewardSearchError: null,
  rewardsTransactionLoding: false,
  rewardsTransactionList: null,
  error: null,
  rewardsPointsloading: false,
  rewardsPoints: null,
  rewardsPointsError: null,
  rewardsPointsAdjustmentsDetailsloading: false,
  rewardsPointsAdjustmentsDetails: null,
  rewardsPointsAdjustmentsDetailsError: null,
  rewardsUserPreferenceloading: false,
  rewardsUserPreferenceError: null,
  rewardsUserPreference: null,
  redeemRewardsAuthorizationLoding: false,
  redeemRewardsAuthorizationList: null,
  authorizationerror: null,
  updateRedeemRewardsAuthorization: null,
  updateredeemRewardsAuthorizationLoding: false,
  updateauthorizationerror: null,
  authorizationReprocess: null,
  authorizationReprocessLoding: null,
  authorizationReprocessError: null,
  rewardsPercentageDate: null,
  rewardsPercentageDateLoading: false,
  rewardsPercentageDateError: null,
  noEligibleTransaction: false,
};

const redeemRewardsSlice = createSlice({
  name: 'redeemRewards',
  initialState,
  reducers: {
    // Fetch rewards redeemers status
    fetchRedeemRewardsRequest(state, action) {
      state.redeemRewardsLoding = true;
      state.redeemRewardsError = null;
    },
    fetchRedeemRewardsSuccess(state, action) {
      state.redeemRewardsLoding = false;
      state.redeemRewardsData = action.payload;
      state.redeemRewardsError = null;
    },
    fetchRedeemRewardsFailure(state, action) {
      state.redeemRewardsLoding = false;
      state.redeemRewardsError = action.payload;
    },

    fetchRedeemRewardsPreferenceRequest(state, action) {
      state.redeemRewardsPreferenceLoding = true;
      state.redeemRewardsPreferenceError = null;
    },
    fetchRedeemRewardsPreferenceSuccess(state, action) {
      state.redeemRewardsPreferenceData = action.payload;
      state.redeemRewardsPreferenceLoding = false;
      state.redeemRewardsPreferenceError = null;
    },
    fetchRedeemRewardsPreferenceFailure(state, action) {
      state.redeemRewardsPreferenceLoding = false;
      state.redeemRewardsPreferenceError = action.payload;
    },

    updateRedeemRewardsPreferenceRequest(state, action) {
      state.updateredeemRewardsPreferenceLoding = true;
      state.updateredeemRewardsPreferenceError = null;
    },
    updateRedeemRewardsPreferenceSuccess(state, action) {
      state.updateRedeemRewardsPreferenceData = action.payload;
      state.updateredeemRewardsPreferenceLoding = false;
      state.updateredeemRewardsPreferenceError = null;
    },
    updateRedeemRewardsPreferenceFailure(state, action) {
      state.updateredeemRewardsPreferenceLoding = false;
      state.updateredeemRewardsPreferenceError = action.payload;
    },
    updateRedeemRewardsPreferenceState(state, action) {
      state.updateredeemRewardsPreferenceError = null;
    },
    redeemRewardSearchRequest(state, action) {
      state.redeemRewardSearchLoading = true;
      state.redeemRewardSearchError = null;
    },
    redeemRewardSearchSuccess(state, action) {
      state.redeemRewardSearchData = action.payload;
      state.updateRedeemRewardsPreferenceData = null;
      state.redeemRewardSearchLoading = false;
      state.redeemRewardSearchError = null;
    },
    redeemRewardSearchFailure(state, action) {
      state.redeemRewardSearchLoading = false;
      state.updateRedeemRewardsPreferenceData = null;
      state.redeemRewardSearchError = action.payload;
    },
    // Fetch rewards Transactions status
    fetchRewardsTransactionRequest(state, action) {
      state.rewardsTransactionLoding = true;
      state.error = null;
    },
    fetchRewardsTransactionSuccess(state, action) {
      state.rewardsTransactionLoding = false;
      state.rewardsTransactionList = action.payload;
      state.error = null;
    },
    fetchRewardsTransactionFailure(state, action) {
      state.rewardsTransactionLoding = false;
      state.error = action.payload;
    },
    redeemRewardsPointsRequest(state, action) {
      state.rewardsPointsloading = true;
      state.rewardsPointsError = null;
    },
    redeemRewardsPointsSuccess(state, action) {
      state.rewardsPointsloading = false;
      state.rewardsPoints = action.payload;
      state.rewardsPointsError = null;
    },
    redeemRewardsPointsFailed(state, action) {
      state.rewardsPointsloading = false;
      state.rewardsPointsError = action.payload;
    },
    resetRedeemRewardsPointsSlice(state) {
      return initialState; // Reset the slice to its initial state
    },

    redeemRewardsPointsAdjustmentsDetailsRequest(state, action) {
      state.rewardsPointsAdjustmentsDetailsloading = true;
      state.rewardsPointsAdjustmentsDetailsError = null;
    },
    redeemRewardsPointsAdjustmentsDetailsSuccess(state, action) {
      state.rewardsPointsAdjustmentsDetails = action.payload;
      state.rewardsPointsAdjustmentsDetailsloading = false;
      state.rewardsPointsAdjustmentsDetailsError = null;
    },
    redeemRewardsPointsAdjustmentsDetailsFailed(state, action) {
      state.rewardsPointsAdjustmentsDetailsloading = false;
      state.rewardsPointsAdjustmentsDetailsError = action.payload;
    },

    rewardsUserPreferenceRequest(state, action) {
      state.rewardsUserPreferenceloading = true;
      state.rewardsUserPreferenceError = null;
    },
    rewardsUserPreferenceSuccess(state, action) {
      state.rewardsUserPreferenceloading = false;
      state.rewardsUserPreference = action.payload;
      state.rewardsUserPreferenceError = null;
    },
    rewardsUserPreferenceFailed(state, action) {
      state.rewardsUserPreferenceloading = false;
      state.rewardsUserPreferenceError = action.payload;
    },
    // Fetch redeem rewards authorization status
    fetchRedeemRewardsAuthorizationRequest(state, action) {
      state.redeemRewardsAuthorizationLoding = true;
      state.authorizationerror = null;
    },
    fetchRedeemRewardsAuthorizationSuccess(state, action) {
      state.redeemRewardsAuthorizationLoding = false;
      state.redeemRewardsAuthorizationList = action.payload;
      state.authorizationerror = null;
    },
    fetchRedeemRewardsAuthorizationFailure(state, action) {
      state.redeemRewardsAuthorizationLoding = false;
      state.authorizationerror = action.payload;
    },

    // update redeem rewards authorization status
    updateRedeemRewardsAuthorizationRequest(state, action) {
      state.updateredeemRewardsAuthorizationLoding = true;
      state.updateauthorizationerror = null;
    },
    updateRedeemRewardsAuthorizationSuccess(state, action) {
      state.updateredeemRewardsAuthorizationLoding = false;
      state.updateRedeemRewardsAuthorization = action.payload;
      state.updateauthorizationerror = null;
    },
    updateRedeemRewardsAuthorizationFailure(state, action) {
      state.updateredeemRewardsAuthorizationLoding = false;
      state.updateauthorizationerror = action.payload;
    },

    // update redeem rewards authorization reprocess status
    authorizationReprocessRequest(state, action) {
      state.authorizationReprocessLoding = true;
      state.authorizationReprocessError = null;
    },
    authorizationReprocessSuccess(state, action) {
      state.authorizationReprocessLoding = false;
      state.authorizationReprocess = action.payload;
      state.authorizationReprocessError = null;
    },
    authorizationReprocessFailure(state, action) {
      state.authorizationReprocessLoding = false;
      state.authorizationReprocessError = action.payload;
    },
    updateStateAfterRedeeption(state) {
      state.updateredeemRewardsAuthorizationLoding = false;
      state.updateRedeemRewardsAuthorization = null;
      state.updateauthorizationerror = null;
      state.authorizationReprocess = null;
    },

    rewardsPercentageDateRequest(state) {
      state.rewardsPercentageDateLoading = true;
      state.rewardsPercentageDate = null;
      state.rewardsPercentageDateError = null;
    },
    rewardsPercentageDateSuccess(state, action) {
      state.rewardsPercentageDateLoading = false;
      state.rewardsPercentageDate = action.payload;
      state.rewardsPercentageDateError = null;
    },
    rewardsPercentageDateFailure(state, action) {
      state.rewardsPercentageDateLoading = false;
      state.rewardsPercentageDate = null;
      state.rewardsPercentageDateError = action.payload;
    },
    noEligibleTransactionFlag(state, action) {
      state.noEligibleTransaction = action.payload;
    },
  },
});

export const {
  fetchRedeemRewardsRequest,
  fetchRedeemRewardsSuccess,
  fetchRedeemRewardsFailure,
  fetchRedeemRewardsPreferenceRequest,
  fetchRedeemRewardsPreferenceSuccess,
  fetchRedeemRewardsPreferenceFailure,
  updateRedeemRewardsPreferenceRequest,
  updateRedeemRewardsPreferenceSuccess,
  updateRedeemRewardsPreferenceFailure,
  updateRedeemRewardsPreferenceState,
  redeemRewardSearchRequest,
  redeemRewardSearchSuccess,
  redeemRewardSearchFailure,
  fetchRewardsTransactionRequest,
  fetchRewardsTransactionSuccess,
  fetchRewardsTransactionFailure,
  redeemRewardsPointsRequest,
  redeemRewardsPointsSuccess,
  redeemRewardsPointsFailed,
  resetRedeemRewardsPointsSlice,
  redeemRewardsPointsAdjustmentsDetailsRequest,
  redeemRewardsPointsAdjustmentsDetailsSuccess,
  redeemRewardsPointsAdjustmentsDetailsFailed,
  rewardsUserPreferenceRequest,
  rewardsUserPreferenceSuccess,
  rewardsUserPreferenceFailed,
  fetchRedeemRewardsAuthorizationRequest,
  fetchRedeemRewardsAuthorizationSuccess,
  fetchRedeemRewardsAuthorizationFailure,
  updateRedeemRewardsAuthorizationRequest,
  updateRedeemRewardsAuthorizationSuccess,
  updateRedeemRewardsAuthorizationFailure,
  authorizationReprocessRequest,
  authorizationReprocessSuccess,
  authorizationReprocessFailure,
  updateStateAfterRedeeption,
  rewardsPercentageDateRequest,
  rewardsPercentageDateSuccess,
  rewardsPercentageDateFailure,
  noEligibleTransactionFlag,
} = redeemRewardsSlice.actions;

export default redeemRewardsSlice.reducer;
